<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div class="bg-white padding-xl" style="position:relative;">
			<Form ref="formTxSetting" :model="formTxSetting" label-position="right" :label-width="100" label-colon>
				<FormItem label="手续费">
					<Input v-model="formTxSetting.sxf" maxlength="4" style="width:100px; text-align: right;"></Input> %
				</FormItem>
				<FormItem label="最小积分">
					<Input v-model="formTxSetting.zxje" maxlength="4" style="width:100px; text-align: right;"></Input> 积分
					<p class="text-grey">
						<Icon type="ios-information-circle-outline" /> 最小提现积分数。</p>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="submitTxSetting('formTxSetting')" :loading="loading">提交</Button>
				</FormItem>
			</Form>
			<Spin fix v-if="loading">
				<Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
				<div>处理中...</div>
			</Spin>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				formTxSetting: {
					sxf: 0,
					zxje: 0
				}
			};
		},
		methods: {
			loadinfo() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/client/tx/setting.php?a=init').then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.formTxSetting = res.data.data;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			submitTxSetting: function(name) {
				this.loading = true;
				this.$http.post('/server/api/client/tx/setting.php?a=settingup', this.$qs.stringify(this.formTxSetting)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							this.$Message.success('更新成功!');
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			}
		},
		created() {
			//console.log(this.searchForm)
			this.loadinfo();
		}
	};
</script>

<style>
</style>
